import { tv } from 'tailwind-variants';

export const linearProgressStyle = tv({
  slots: {
    base: 'relative',
    background: 'relative h-full w-full overflow-hidden rounded-full',
    foreground: 'absolute h-full rounded-[inherit]'
  },

  variants: {
    flat: {
      true: {
        background: 'rounded-none'
      }
    },
    color: {
      primary: {
        background: 'bg-primary/10',
        foreground: 'bg-primary'
      },
      secondary: {
        background: 'bg-secondary/10',
        foreground: 'bg-secondary'
      },
      tertiary: {
        background: 'bg-tertiary/10',
        foreground: 'bg-tertiary'
      },
      black: {
        background: 'bg-black/10',
        foreground: 'bg-black'
      },
      success: {
        background: 'bg-success/10',
        foreground: 'bg-success'
      },
      good: {
        background: 'bg-good/10',
        foreground: 'bg-good'
      },
      neutral: {
        background: 'bg-neutral/10',
        foreground: 'bg-neutral'
      },
      info: {
        background: 'bg-info/10',
        foreground: 'bg-info'
      },
      error: {
        background: 'bg-error/10',
        foreground: 'bg-error'
      },
      warning: {
        background: 'bg-warning/10',
        foreground: 'bg-warning'
      }
    },
    indeterminate: {
      true: {
        foreground: 'animate-infinite-progress w-full origin-left'
      }
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
